(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _nav = require("./parts/nav.js");
var _video = require("./parts/video.js");
var _loadmore = require("./parts/loadmore.js");
var _search = require("./parts/search.js");
window.addEventListener("load", function (event) {
  (0, _nav.nav)();
  (0, _video.video)();
  (0, _loadmore.loadmore)();
  (0, _search.search)();
});

},{"./parts/loadmore.js":2,"./parts/nav.js":3,"./parts/search.js":4,"./parts/video.js":6}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadmore = loadmore;
function loadmore() {
  var container = document.getElementById('post-container');
  if (!container) return;
  var button = document.getElementById('load-more-posts');
  if (!button) return;
  var postsToShow = parseInt(container.dataset.postsToShow || 6);
  var columns = parseInt(container.dataset.columns || 3);
  var postType = container.dataset.postType;
  var showShortCopy = parseInt(container.dataset.showShortCopy);
  var centerCards = container.dataset.centerCards === 'true';
  var loading = false;
  var currentPage = 1;

  // --- Handle Show More click ---
  button.addEventListener('click', function (e) {
    e.preventDefault();
    if (loading) return;
    var nextPage = parseInt(button.dataset.nextPage || 2);
    loading = true;
    button.textContent = 'Loading...';
    fetch(loadmore_params.ajax_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({
        action: 'load_more_posts',
        page: nextPage,
        postsToShow: postsToShow,
        columns: columns,
        showShortCopy: showShortCopy,
        centerCards: centerCards,
        postType: postType
      })
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      container.insertAdjacentHTML('beforeend', data.html);
      var maxPages = parseInt(data.max);
      if (nextPage >= maxPages) {
        button.style.display = 'none';
      } else {
        button.dataset.nextPage = nextPage + 1;
        button.textContent = 'Show More';
      }
      var basePath = window.location.pathname.replace(/\/page\/\d+\/?$/, '') // remove existing pagination
      .replace(/\/$/, ''); // remove trailing slash

      var url = nextPage === 1 ? basePath + '/' : basePath + '/page/' + nextPage + '/';
      history.pushState({
        page: nextPage,
        html: container.innerHTML
      }, '', url);
      currentPage = nextPage;
      loading = false;
    }).catch(function (err) {
      console.error(err);
      button.textContent = 'Show More';
      loading = false;
    });
  });
  // --- Handle back/forward buttons ---
  window.addEventListener('popstate', function (e) {
    if (!e.state) return;
    container.innerHTML = e.state.html;
    currentPage = e.state.page || 1;

    // Update next page for button
    if (button) button.dataset.nextPage = currentPage + 1;
  });

  // --- Initialize history on first page load ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHistory);
  } else {
    initHistory();
  }
  function initHistory() {
    if (!history.state) {
      history.replaceState({
        page: 1,
        html: container.innerHTML
      }, '', window.location.href);
    }
  }
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nav = nav;
var _utilities = require("./utilities.js");
function nav() {
  var openMenu = null;
  var lockHeaderAnimation = false;
  var originNav = void 0;
  var header = document.querySelector('header');
  var headerContainer = document.querySelector('header .container');
  var subUnit = document.querySelector('.sub-unit');
  var overlay = document.getElementById('mobile-nav-overlay');
  var hamburger = document.querySelector('.mobile-nav .hamburger');
  var slideout = document.querySelector('.mobile-nav-slideout');
  var setFocusOnClose = true;

  // Mobile Nav Sub Nav Items
  var menuwithsubs = document.querySelectorAll('.menu-item-has-children > a');
  menuwithsubs.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      var subMenu = item.parentElement.querySelector('ul');
      if (subMenu.classList.contains('slide-open')) {
        (0, _utilities.slideUp)(subMenu);
      } else {
        (0, _utilities.slideDown)(subMenu);
      }
    });
  });

  // =========================
  // Header scroll handling
  // =========================
  window.addEventListener("scroll", function () {
    if (lockHeaderAnimation) return;
    if (window.scrollY > 100) {
      header?.classList.add("scrolled");
      headerContainer?.classList.add("scrolled");
      subUnit?.classList.add("scrolled");
    } else if (window.scrollY <= 10) {
      header?.classList.remove("scrolled");
      headerContainer?.classList.remove("scrolled");
      subUnit?.classList.remove("scrolled");
    }
  });

  // =========================
  // Mobile nav toggle
  // =========================
  overlay.classList.add('mobile-nav-overlay');
  document.body.appendChild(overlay);
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      document.body.classList.toggle('no-scroll');
      window.scrollTo({
        top: 0
      });
      this.classList.toggle('active');
      slideout.classList.toggle('open');
      overlay.classList.toggle('active');
    });
  }
  overlay.addEventListener('click', function () {
    hamburger.classList.remove('active');
    slideout.classList.remove('open');
    originNav?.classList.toggle('open');
    overlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
    if (openMenu) closeMenu(openMenu);
  });

  // =========================
  // Mega Menu
  // =========================
  // Select <a> inside each <li[post]> so we always intercept clicks
  var navLinks = document.querySelectorAll('#menu-ki-main li[post] > a');
  navLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var li = this.parentElement; // <li> with post
      var postId = li.getAttribute('post');
      var submenu = document.querySelector(".sub-nav-container[post=\"" + postId + "\"]");
      originNav = this;

      // If there’s a mega menu, always prevent navigation
      if (submenu) {
        e.preventDefault(); // MUST preventDefault first
        e.stopPropagation(); // stop bubbling just in case
        navLinks.forEach(function (l) {
          return l.classList.remove('open');
        }); // Close all other links

        // Lock header scroll animations
        lockHeaderAnimation = true;

        // Close other open menu if needed
        if (openMenu && openMenu !== submenu) {
          closeMenu(openMenu);
        }

        // Toggle current menu
        if (submenu.classList.contains('open')) {
          closeMenu(submenu);
          openMenu = null;
          lockHeaderAnimation = false;
        } else {
          link.classList.add('open');
          // Open in next animation frame to avoid scroll race
          requestAnimationFrame(function () {
            openMenuFn(submenu);
            openMenu = submenu;
            // Set focus to 
            requestAnimationFrame(function () {
              var focusableSelectors = "\n                            a,\n                            area[href],\n                            input:not([disabled]),\n                            select:not([disabled]),\n                            textarea:not([disabled]),\n                            button:not([disabled]),\n                            iframe,\n                            [tabindex]:not([tabindex=\"-1\"]),\n                            [contenteditable=\"true\"]\n                        ";
              var allFocusable = submenu.querySelectorAll(focusableSelectors);
              var firstFocusable = submenu.querySelector(focusableSelectors);
              var lastFocusable = allFocusable[allFocusable.length - 1];
              setFocusOnClose = false;
              console.log('firstFocusable: ', firstFocusable);
              if (firstFocusable) {
                firstFocusable.focus();
              }
              if (lastFocusable) {
                lastFocusable.addEventListener('keydown', function (event) {
                  if (event.key === 'Tab') {
                    closeMenu(submenu);
                    openMenu = null;
                    lockHeaderAnimation = false;
                    link.classList.remove('open');
                  }
                });
              }

              // ESC closed mega menu
              submenu.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') {
                  closeMenu(submenu);
                  openMenu = null;
                  lockHeaderAnimation = false;
                  link.classList.remove('open');
                }
              });
            });
          });
        }
      }

      // else → normal link navigation happens
    });
  });

  // =========================
  // Open Menu Function
  // =========================
  function openMenuFn(menu) {
    // Instantly expand header without animation
    header?.classList.add('no-transition');
    header?.classList.remove('scrolled');
    headerContainer?.classList.remove('scrolled');
    subUnit?.classList.remove('scrolled');

    // Jump to top
    window.scrollTo(0, 0);
    overlay.classList.add('active');
    // Animate menu
    requestAnimationFrame(function () {
      menu.style.display = 'block';
      var height = menu.scrollHeight;
      console.log('height:', height);
      menu.style.height = '0px';
      requestAnimationFrame(function () {
        menu.style.height = height + 'px';
      });
      menu.classList.add('open');

      // Re-enable header animation
      header?.classList.remove('no-transition');
    });
  }

  // =========================
  // Close Menu Function
  // =========================
  function closeMenu(menu) {
    console.log('just in: ', menu);
    if (!menu) return;
    overlay.classList.remove('active');
    var height = menu.scrollHeight;
    menu.style.height = height + 'px';
    requestAnimationFrame(function () {
      menu.style.height = '0px';
    });
    setTimeout(function () {
      console.log('menu closed: ', menu);
      menu.style.display = 'none';
      menu.classList.remove('open');
      //openMenu = null;
      lockHeaderAnimation = false;
      if (setFocusOnClose && originNav) {
        originNav.focus();
        setFocusOnClose = true;
      }
    }, 350);
  }
}

},{"./utilities.js":5}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.search = search;
function search() {
  var searchBtn = document.getElementById('search-toggle');
  var searchContainer = document.getElementById('search');
  var searchInput = document.querySelector('#search input');
  var searchClose = document.getElementById('close-search');
  if (searchBtn) {
    searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      searchContainer.classList.toggle('search-open');
      searchInput.focus();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      searchContainer?.classList.remove('search-open');
      searchBtn.focus();
    }
  });
  if (searchClose) {
    searchClose.addEventListener('click', function (e) {
      searchContainer?.classList.remove('search-open');
      searchBtn.focus();
    });
  }

  //--------------------------------------------
  // Search Load More
  //--------------------------------------------
  var btn = document.getElementById('load-more-search');
  if (!btn) return;
  var page = btn.dataset.page;
  var searchTerm = btn.dataset.searchTerm;
  var max = parseInt(btn.dataset.max, 10);
  var container = document.getElementById('search-posts');
  page++;
  btn.addEventListener('click', function () {
    btn.disabled = true;
    btn.textContent = 'Loading...';
    var formData = new FormData();
    formData.append('action', 'load_more_search_posts');
    formData.append('page', page);
    //formData.append('query', loadmore_params.query_vars);
    formData.append('s', searchTerm);
    fetch(loadmore_params.ajax_url, {
      method: 'POST',
      body: formData
    }).then(function (res) {
      return res.json();
    }) // ✅ CHANGE THIS
    .then(function (data) {
      if (data.html.trim()) {
        container.insertAdjacentHTML('beforeend', data.html);
        btn.disabled = false;
        btn.textContent = 'Load More';
        page++;
        btn.dataset.page = page;
        if (page >= data.max) {
          btn.remove();
        }
      } else {
        btn.remove();
      }
    }).catch(function (err) {
      console.error(err);
      btn.disabled = false;
      btn.textContent = 'Load More';
    });
  });
}

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slideDown = slideDown;
exports.slideUp = slideUp;
function slideDown(element) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var animateOpacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  element.style.display = "block";
  element.style.overflow = "hidden";
  element.style.height = "0px";
  var originalDisplay = getComputedStyle(element).display === 'none' ? 'block' : getComputedStyle(element).display;
  if (animateOpacity) {
    element.style.opacity = "0"; // Start fully transparent
  }
  var endHeight = element.scrollHeight;
  requestAnimationFrame(function () {
    var startTime = performance.now();
    var onComplete = function onComplete(element) {
      element.style.overflow = "";
      element.style.overflowY = "auto";
      element.style.overflowX = "hidden";
      element.classList.add('slide-open');
    };
    function animate(currentTime) {
      element.style.overflowY = "hidden";
      var elapsedTime = currentTime - startTime;
      var progress = Math.min(elapsedTime / duration, 1);
      element.style.height = progress * endHeight + "px";
      if (animateOpacity) {
        element.style.opacity = progress; // Increase opacity if enabled
      }
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        element.style.height = ""; // reset height
        element.style.display = originalDisplay;
        if (animateOpacity) {
          element.style.opacity = "";
        }
        if (typeof onComplete === "function") {
          onComplete(element);
        }
      }
    }
    requestAnimationFrame(animate);
  });
}
function slideUp(element) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var animateOpacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  element.style.overflow = "hidden";
  var startHeight = element.scrollHeight;
  if (animateOpacity) {
    element.style.opacity = "1"; // Ensure it's fully visible
  }
  requestAnimationFrame(function () {
    var startTime = performance.now();
    function animate(currentTime) {
      var elapsedTime = currentTime - startTime;
      var progress = Math.min(elapsedTime / duration, 1);
      element.style.height = (1 - progress) * startHeight + "px";
      if (animateOpacity) {
        element.style.opacity = 1 - progress; // Decrease opacity if enabled
      }
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        element.style.display = "none";
        element.classList.remove('slide-open');
        element.style.height = "";
        if (animateOpacity) {
          element.style.opacity = "";
        }
      }
    }
    requestAnimationFrame(animate);
  });
}

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.video = video;
function video() {
  var overlay = document.getElementById('youtube-container');
  var main = document.getElementById('main');
  var closeVideo = document.getElementById('close-video');
  var transcriptLink = document.getElementById('youtube-video-transcript');

  // For Single
  var videoId = main.getAttribute('data-video-id-single');
  var origin = void 0;

  //YOUTUBE API
  // GLOBAL SCOPE
  window.ytPlayer = null;
  var youtubeApiLoading = false;
  var youtubeApiLoaded = false;
  var ytAPIPromise = void 0;
  function loadYouTubeAPI() {
    if (window.YT?.Player) {
      return Promise.resolve();
    }
    if (ytAPIPromise) {
      return ytAPIPromise;
    }
    ytAPIPromise = new Promise(function (resolve) {
      var existingScript = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
      if (!existingScript) {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }
      var check = setInterval(function () {
        if (window.YT?.Player) {
          clearInterval(check);
          resolve();
        }
      }, 50);
    });
    return ytAPIPromise;
  }
  function initPlayer(videoId) {
    return loadYouTubeAPI().then(function () {
      if (!window.ytPlayer) {
        window.ytPlayer = new YT.Player('youtube-player', {
          videoId: videoId,
          playerVars: {
            autoplay: 1,
            controls: 1,
            rel: 0,
            modestbranding: 1
          }
        });
      } else {
        window.ytPlayer.loadVideoById(videoId);
      }
    });
  }
  //YOUTUBE API

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.video-button');
    origin = btn;
    if (!btn) return; // click was not on a video-button

    e.preventDefault();
    var videoId = btn.getAttribute('data-video-id');
    var transcript = btn.getAttribute('data-transcript');
    if (transcript) {
      transcriptLink.setAttribute('href', transcript);
      transcriptLink.style.display = transcript ? 'inline-block' : 'none';
    }
    if (!videoId) return;
    overlay.classList.add('active');
    initPlayer(videoId).then(function () {
      closeVideo.focus();
    });
  });
  transcriptLink?.addEventListener('click', function (e) {
    e.stopPropagation();
  });
  if (closeVideo) {
    closeVideo.addEventListener('click', function (e) {
      console.log(e);
      window.ytPlayer.stopVideo();
      overlay.classList.remove('active');
    });
  }
  if (overlay) {
    overlay.addEventListener('click', function (e) {
      console.log(e);
      window.ytPlayer.stopVideo();
      overlay.classList.remove('active');
    });
    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        window.ytPlayer.stopVideo();
        overlay.classList.remove('active');
        origin.focus();
      }
    });
  }

  //check for single
  if (window.ytPlayerSingle && videoId) {
    window.ytPlayerSingle.cueVideoById(videoId);
  }
  var singlePlay = document.getElementById('single-video-play');
  if (singlePlay) {
    singlePlay.addEventListener('click', function (e) {
      e.preventDefault();
      var theVideo = e.currentTarget.dataset.video;
      var singleImage = document.getElementById('single-video-thumb');
      var parent = e.currentTarget.parentElement;
      // Prevent double clicks
      if (parent.classList.contains('is-hiding')) {
        return;
      }
      parent.classList.add('is-hiding');
      // IMPORTANT:
      // Start playback INSIDE user click event
      if (window.ytPlayerSingle && typeof window.ytPlayerSingle.loadVideoById === 'function') {
        window.ytPlayerSingle.loadVideoById(theVideo);
      }
      // Parent fade
      if (parent) {
        parent.addEventListener('transitionend', function (ev) {
          parent.style.display = 'none';
        }, {
          once: true
        });
      }

      // Image fade
      if (singleImage) {
        singleImage.addEventListener('transitionend', function (ev) {
          if (ev.propertyName !== 'opacity') return;
          singleImage.style.display = 'none';
        }, {
          once: true
        });
      }

      // Trigger fade LAST
      requestAnimationFrame(function () {
        if (parent) {
          parent.classList.add('hide');
        }
        if (singleImage) {
          singleImage.classList.add('hide');
        }
      });
    });
  }
  var videos = document.querySelectorAll('.lazy-video');
  if ('IntersectionObserver' in window && videos.length) {
    var isMobile = window.matchMedia("(max-width: 781px)").matches;
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var video = entry.target;
        obs.unobserve(video);
        if (isMobile) {
          video.classList.add('is-ready');
          return;
        }

        // Prevent double load
        if (video.dataset.loaded) return;
        var source = video.querySelector('source[data-src]');
        if (!source) return;
        video.dataset.loaded = "1";
        source.src = source.dataset.src;
        var init = function init() {
          video.load();
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {
              video.setAttribute('controls', '');
            });
          }
          video.classList.add('is-ready');
        };
        requestAnimationFrame(init);
      });
    }, {
      rootMargin: "400px 0px",
      threshold: 0.01
    });
    for (var i = 0; i < videos.length; i++) {
      observer.observe(videos[i]);
    }
  }
}

},{}]},{},[1]);
